import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import Title from '../components/Title';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";

const Orders = () => {
   useEffect(() => {
      const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
      axios.post(`${backendUrl}/api/analytics/visit`, { page: "Orders" })
        .then(res => console.log(" visit recorded:", res.data))
        .catch(err => console.error("Analytics error:", err));
    }, []);
  const { backendUrl, token, currency,totalAmount } = useContext(ShopContext);
  const [orderData, setOrderData] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null); // Track order for cancellation
  const navigate = useNavigate();

  const loadOrderData = async () => {
    try {
      if (!token) return;
      const response = await axios.post(
        backendUrl + '/api/order/userorders',
        {},
        { headers: { token } }
      );

      if (response.data.success) {
        let allOrdersItem = [];
        response.data.orders.forEach(order => {
          order.items.forEach(item => {
            item['orderId'] = order._id;
            item['status'] = order.status;
            item['payment'] = order.payment;
            item['paymentMethod'] = order.paymentMethod;
            item['date'] = order.date;
            item['amount'] = order.amount;
            allOrdersItem.push(item);
          });
        });
        setOrderData(allOrdersItem.reverse());
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadOrderData();
  }, [token]);

  const cancelOrder = async () => {
    if (!selectedOrder) return;

    try {
      const response = await axios.post(
        backendUrl + '/api/order/cancelOrder',
        { orderId: selectedOrder },
        { headers: { token } }
      );

      if (response.data.success) {
        setOrderData(prevData =>
          prevData.map(item =>
            item.orderId === selectedOrder ? { ...item, status: 'Order Canceled' } : item
          )
        );
        setSelectedOrder(null); // Close modal after cancellation
      } else {
        console.error('Failed to cancel order:', response.data);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const colorMapping = {
    "#F6F6F6": "Bone White",
    "#151515": "Magma Black",
    "#D5C6DA": "Ancient Lavender",
    "#A7AA94": "Moss Green",
    "#242E44": "Midnight Blue",
    "#90867D": "Amber Crust",
    "#FAEEB2": "Ivory Ember",
  };

  return (
    <>
      <Helmet>
        <title>My Orders - E-Commerce</title>
        <meta name="description" content="Track and manage your orders" />
        <meta name="keywords" content="Order Tracking, E-Commerce Orders, {currency}" />
      </Helmet>

      <div className="border-t pt-16 px-4 lg:px-8">
        <div className="flex justify-center items-center mb-6">
          <button
            className={`px-6 py-2 rounded-l-sm ${
              window.location.pathname === "/profile" ? "bg-[#FF4902] text-white" : "bg-gray-300 text-black"
            }`}
            onClick={() => navigate("/profile")}
          >
            Profile
          </button>
          <button
            className={`px-6 py-2 rounded-r-sm ${
              window.location.pathname === "/orders" ? "bg-[#FF4902] text-white" : "bg-gray-300 text-black"
            }`}
            onClick={() => navigate("/orders")}
          >
            Orders
          </button>
        </div>

        <div className="text-2xl mb-8">
          <Title text1={'MY'} text2={'ORDERS'} />
        </div>
        
        <div className="space-y-8">
          {orderData.map((item, index) => (
            <div key={index} className="py-6 px-6 border border-black rounded-lg lg:gap-8 lg:py-8 lg:px-8">
              <div className="flex flex-col lg:flex-row gap-8 items-start lg:gap-12">
                {/* Order Details */}
                <div className="flex flex-col gap-6 lg:gap-8 w-full lg:w-2/3">
                  <div className="flex items-center gap-6 lg:gap-8">
                    <img className="w-32 sm:w-48 md:w-56 lg:w-64 rounded-lg" src={item.image[0]} alt={item.name} />
                    <div className="flex flex-col gap-3 lg:gap-4">
                      <p className="text-lg sm:text-xl font-medium">{item.name}</p>
                      <div className="flex flex-wrap gap-3 mt-2 text-sm sm:text-base text-gray-700">
                        {/* <p>{currency}{item.price}</p> */}
                        {/* <p>total amount: {totalAmount}</p> */}
                        <p>Total Amount: {item.amount}</p>
                        <p>Quantity: {item.quantity}</p>   <br />
                        <p>Size: {item.size}</p>
                        <p>Color: {colorMapping[item.color] || item.color}</p>
                       
                      </div>
                      <p className="mt-2 text-sm lg:mt-3">
                        Date: <span className="text-gray-400">{new Date(item.date).toDateString()}</span>
                      </p>
                      <p className="text-sm lg:mt-1">
                        Payment Method: <span className="text-gray-400">{item.paymentMethod}</span>
                      </p>
                    </div>
                  </div>

                  {/* Cancel Order Button */}
                  <div className="mt-4 lg:mt-6">
                    <button
                      onClick={() => setSelectedOrder(item.orderId)} // Show confirmation modal
                      disabled={item.status === 'Order Canceled' || item.payment}
                      className={`border px-4 py-2 text-sm font-medium rounded-sm ${
                        item.status === 'Order Canceled' ? 'bg-gray-500' : 'bg-red-500'
                      } text-white`}
                    >
                      {item.status === 'Order Canceled' ? 'Order Canceled' : 'Cancel Order'}
                    </button>
                  </div>
                </div>

                {/* Order Progress */}
                <div className="w-full lg:w-1/3">
                  <div className="text-sm mb-4 lg:mb-6">Order Progress:</div>
                  <ul className="steps steps-vertical gap-2">
                    {['Order Placed', 'Packing', 'Shipped', 'Out for Delivery', 'Delivered'].map((stage, idx) => (
                      <li key={idx} className={`step ${item.status === stage ? 'step-primary' : 'step-secondary text-gray-500'}`}>
                        {stage}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Confirmation Modal */}
      {selectedOrder && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-lg font-semibold mb-4">Confirm Cancellation</h2>
              <p className="text-gray-700 mb-4">
                Are you sure you want to cancel this order?
              </p>
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setSelectedOrder(null)}
                  className="px-4 py-2 bg-gray-300 text-black rounded"
                >
                  No, Keep Order
                </button>
                <button
                  onClick={cancelOrder}
                  className="px-4 py-2 bg-red-500 text-white rounded"
                >
                  Yes, Cancel Order
                </button>
              </div>
            </div>
          </div>
        )}

    </>
  );
};

export default Orders;
